import { adjectives } from './lists.js';
export function isAllAdjectives(str) {
    const words = str.split(/\s+/g);
    return words.every((word) => adjectives.includes(word));
}
//# sourceMappingURL=adjectives.js.map